import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';

export default function PageHeader({ eyebrow, title, lead, crumb, children }) {
  const { t } = useLang();
  return (
    <header className="page-header">
      <div className="hero-grid" aria-hidden="true" />
      <div className="container page-header__inner">
        <nav className="crumbs" aria-label="Breadcrumb">
          <Link to="/">{t.common.home}</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{crumb}</span>
        </nav>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="page-header__title">{title}</h1>
        {lead && <p className="page-header__lead">{lead}</p>}
        {children}
      </div>
    </header>
  );
}
